import React from 'react'
import T from '../i18n/T'
import { useAction } from '../utils/react-redux'
import { resetSearchHistory } from '../../store/search/searchHistory/searchHistory.actions'
import useEventCallback from '../utils/useEventCallback'
import s from './SuggestClearHistory.less'
import { isEmpty } from '../../utils/lang'

const SuggestClearHistory = ({ suggestionsSearchHistory }) => {
  const hasSearchHistorySuggests = !isEmpty(suggestionsSearchHistory)
  const execResetSearchHistory = useAction(resetSearchHistory)

  const onSuggestCleanHistory = useEventCallback(() => {
    execResetSearchHistory()
  }, [])

  if (!hasSearchHistorySuggests) return null
  return (
    <div className={s.SuggestCleanHistory}>
      <span onClick={onSuggestCleanHistory}>
        <T id={'suggest.history.clear'} />
      </span>
    </div>
  )
}

export default SuggestClearHistory
